import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { FiLock, FiEye, FiEyeOff, FiCheckCircle } from "react-icons/fi";
import api from "../services/api";
import "../styles/account.css";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");

    if (password !== confirmPassword) {
      setError("Passwords do not match");
      return;
    }

    if (password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    setLoading(true);

    try {
      await api.auth.resetPassword(token, password);
      setSuccess(true);
      setTimeout(() => {
        navigate("/login");
      }, 3000);
    } catch (err) {
      setError(
        err.message || "Failed to reset password. The link may have expired.",
      );
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="kkb-page">
        <div className="kkb-auth">
          <div className="kkb-auth__container kkb-auth__container--small">
            <div className="kkb-auth__box" style={{ textAlign: "center" }}>
              <FiCheckCircle size={60} color="#27ae60" />
              <h2 style={{ marginTop: "20px", color: "#27ae60" }}>
                Password Reset Successfully!
              </h2>
              <p style={{ marginTop: "10px", color: "#666" }}>
                Your password has been updated. Redirecting to login...
              </p>
              <Link
                to="/login"
                className="kkb-btn kkb-btn--primary"
                style={{ marginTop: "30px" }}
              >
                Go to Login
              </Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="kkb-page">
      <div className="kkb-auth">
        <div className="kkb-auth__container kkb-auth__container--small">
          <div className="kkb-auth__box">
            <div className="kkb-auth__logo">KKB & Co.</div>
            <h2 className="kkb-auth__title" style={{ textAlign: "center" }}>
              Create New Password
            </h2>
            <p
              className="kkb-auth__subtitle"
              style={{ textAlign: "center", marginBottom: "30px" }}
            >
              Please enter your new password below.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="kkb-form__group">
                <label className="kkb-form__label">New Password</label>
                <div className="kkb-form__input-wrap">
                  <FiLock
                    size={16}
                    style={{
                      position: "absolute",
                      left: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#999",
                    }}
                  />
                  <input
                    className="kkb-form__input"
                    type={showPassword ? "text" : "password"}
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="Enter new password"
                    style={{ paddingLeft: "35px" }}
                    required
                  />
                  <button
                    type="button"
                    className="kkb-form__eye"
                    onClick={() => setShowPassword(!showPassword)}
                    style={{ right: "12px" }}
                  >
                    {showPassword ? (
                      <FiEyeOff size={16} />
                    ) : (
                      <FiEye size={16} />
                    )}
                  </button>
                </div>
              </div>

              <div className="kkb-form__group">
                <label className="kkb-form__label">Confirm New Password</label>
                <div className="kkb-form__input-wrap">
                  <FiLock
                    size={16}
                    style={{
                      position: "absolute",
                      left: "12px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#999",
                    }}
                  />
                  <input
                    className="kkb-form__input"
                    type={showPassword ? "text" : "password"}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    placeholder="Confirm new password"
                    style={{ paddingLeft: "35px" }}
                    required
                  />
                </div>
              </div>

              {error && (
                <div
                  style={{
                    color: "#e74c3c",
                    fontSize: "14px",
                    marginBottom: "15px",
                  }}
                >
                  {error}
                </div>
              )}

              <button
                type="submit"
                className="kkb-btn kkb-btn--primary kkb-btn--full"
                disabled={loading}
              >
                {loading ? "Resetting..." : "Reset Password"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
